import { useQueryTrainerGet } from '@ifit/gateway-trainer-store';
import { useRowQueryOptions } from '../query-options';

export const useTrainerGetOneQuery = (trainerId: string) => {
  const requiredParams = useRowQueryOptions();
  const opts = { ...requiredParams, id: trainerId };
  return useQueryTrainerGet(opts);
};
